import { combineReducers } from "redux";

import menuInternalDocumentSlice from "./menu";
import fromSearchInternalDocumentSlice from "./formSearch";
import getDetailSlice from "./getDetail";
import getListInternalDocsSlice from "./getListInternalDocs";
import getListDocFormSlice from "./getDocForm";

const internalDocumentReducer = combineReducers({
  menuInternalDocumentSlice,
  fromSearchInternalDocumentSlice,
  getDetailSlice,
  getListInternalDocsSlice,
  getListDocFormSlice,
});

export default internalDocumentReducer;
